// @ts-strict-ignore
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootStoreState, appLanguageSelected, Language } from 'mytours-read-common'
import { Button } from '@mytours/components'
import LanguageModal from '../../language-modal'
import strings from '../../../../../strings'
import { changeAppLanguage } from 'mobile_web/modules/settings/changeAppLanguage'

// Also used by the Header to fold this button's visibility into its
// `with-buttons` / fixed-nav layout flags — share this hook rather than
// duplicating the condition there.
export const useShowLanguageButton = (): boolean => {
	const persistLanguageSwitcher = useSelector(
		(state: RootStoreState) => state.settings.appMetaData?.persist_language_switcher,
	)
	const supportedLanguages = useSelector((state: RootStoreState) => state.settings.appMetaData?.supported_languages)
	return Boolean(persistLanguageSwitcher && supportedLanguages && supportedLanguages.length > 1)
}

const LanguageButton: React.FC = () => {
	const [isOpen, setIsOpen] = useState(false)
	const dispatch = useDispatch()

	const showLanguageButton = useShowLanguageButton()
	const supportedLanguages = useSelector((state: RootStoreState) => state.settings.appMetaData?.supported_languages)
	const selectedLanguage = useSelector((state: RootStoreState) => state.settings.selectedLanguage)

	if (!showLanguageButton) {
		return null
	}

	const onChooseLanguage = (language: Language): void => {
		setIsOpen(false)
		changeAppLanguage(supportedLanguages, language, l => dispatch(appLanguageSelected(l)))
	}

	return (
		<>
			<Button
				variant="clear"
				radius="0"
				className="map-button"
				onClick={() => setIsOpen(true)}
				aria-label={strings.select_language}
			>
				<i className="fal fa-language" />
			</Button>
			<LanguageModal
				isOpen={isOpen}
				supportedLanguages={supportedLanguages}
				selectedLanguage={selectedLanguage}
				selectLanguage={onChooseLanguage}
				closeModal={() => setIsOpen(false)}
				onDidDismiss={() => setIsOpen(false)}
			/>
		</>
	)
}

export default LanguageButton
